import { render, staticRenderFns } from "./GeneralStates.vue?vue&type=template&id=6ecb26a0"
import script from "./GeneralStates.vue?vue&type=script&lang=js"
export * from "./GeneralStates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports